export const ka = {
  title: 'მიწის საფარი 2000-2020',
  subtitle: 'UMD',
  download_data: '',
  learn_more: '',
  content: [
    {
      label: 'ფუნქცია',
      value: '2000 და 2020 წლის მიწის გლობალური სამოტივაციო რუკა',
    },
    {
      label: 'რეზოლუცია',
      value: '30 მეტრი',
    },
    {
      label: 'გეოგრაფიული გაშუქება',
      value: 'გლობალური',
    },
    {
      label: 'წყარო',
      value: 'UMD',
    },
    {
      label: 'სიხშირე',
      value: '',
    },
    {
      label: 'შინაარსის თარიღი',
      value: '',
    },
    {
      label: 'გაფრთხილება',
      value:
        '- მიწის საფარის რუქა შეზღუდული იყო Landsat clear-sky მონაცემთა ხელმისაწვდომობით. Landsat დაკვირვების დროის სერიის არასრულფასოვნება ამცირებს რუკის სიზუსტეს რეგიონებში მუდმივი ღრუბლის საფარით. \n- დისკრეტული მიწის საფარის კლასების რუქა ჰეტეროგენულ პეიზაჟებში შეზღუდული იყო შერეული პიქსელების მაღალი პროპორციით Landsat სივრცითი რეზოლუციით. LULC კლასების უმეტესობას აქვს უფრო მაღალი რუკის სიზუსტე დიდ ერთგვაროვან ადგილებში, ვიდრე ფრაგმენტული პეიზაჟები და კლასის პატჩის კიდეები. \n- სპექტრალური მსგავსება LCLU სხვადასხვა კლასებს შორის შეიძლება გამორიცხავდეს კლასის დისკრიმინაციას.\n- ტყის სიმაღლის პროდუქტს აქვს GEDI მონაცემთა ხარისხთან და Landsat მონაცემთა ხელმისაწვდომობასთან დაკავშირებული საკითხები. 2000-2020 წლებში ტყის სიმაღლის მცირე ცვლილებებმა შეიძლება არ მიუთითოს ტყის სტრუქტურის რეალური ცვლილება, მაგრამ წარმოადგენს ხმაურს მოდელის გამოსავალებში. \n- დინამიურ კლასებს (LCLU კლასის დაკარგვა და მოგება) უფრო დაბალი სიზუსტე აქვთ სტატიკურ რუკებთან შედარებით. \n- რუქაზე დაფუძნებული შეფასებები არ არის ადეკვატური ეროვნული და საერთაშორისო რეპორტაჟებისთვის, რუკის გაურკვევლობის უცნობი სივრცითი და დროებითი ცვალებადობის გამო.',
    },
    {
      label: 'ლიცენზია',
      value: 'Creative Commons Attribution (https://glad.umd.edu/dataset/GLCLUC2020) ლიცენზიით',
    },
  ],
  overview: {
    label: 'მიმოხილვა',
    value:
      'გლობალური მიწის გამოყენებისა და მიწის საფარის რუკები შეიქმნა გლობალური მიწის ანალიზისა და აღმოჩენის ლაბორატორიის (GLAD) ლაბორატორიის მიერ, ხოლო მონაცემები ხელმისაწვდომია 30 მ სივრცითი რეზოლუციით 2000 და 2020 წლებისთვის. GLAD ლაბორატორიამ გამოიყენა spatiotemporally თანმიმდევრული [Landsat Analysis Ready Data (GLAD ARD)](https://glad.umd.edu/ard) ტყის მოცულობისა და სიმაღლის, მოსავლის, ჩაშენებული მიწების, ზედაპირული წყლისა და მრავალწლიანი თოვლისა და ყინულის ცვლილების დასადგენად ოცი წლის განმავლობაში. თითოეული თემატური პროდუქტი დამოუკიდებლად იქნა მიღებული თანამედროვე, ადგილობრივად და რეგიონალურად დაკალიბრებული მანქანური სწავლების ინსტრუმენტების გამოყენებით. მონაცემთა ბაზა დადასტურდა სტატისტიკური შერჩევის გამოყენებით, რომელიც ადასტურებს მის მაღალ სიზუსტეს. გლობალური მიწის ანალიზისა და აღმოჩენის ლაბორატორიის (GLAD) ლაბორატორია გეოგრაფიულ მეცნიერებათა დეპარტამენტში UMD იკვლევს მიწის ზედაპირის გლობალური ცვლილების მეთოდებს, მიზეზებს და გავლენას. დედამიწის დაკვირვების სურათები არის მონაცემთა ძირითადი წყარო, ხოლო მიწის საფარის მოცულობა და ცვლილება ინტერესის ძირითადი თემაა. GLAD ისწრაფვის შექმნას ახალი სამეცნიერო შეხედულებები მიწის რესურსებთან დაკავშირებით, განათლება მომავალი თაობის დისტანციური ზონდირებაზე დაფუძნებული მიწის ცვლილების მეცნიერები და გაავრცელოს მიწის მონიტორინგის შესაძლებლობები ოპერაციულ გარემოში ეროვნულ და საერთაშორისო დონეზე.',
  },
  citation: {
    label: 'ციტატა',
    value:
      'Potapov P., Hansen M.C., Pickens A., Hernandez-Serna A., Tyukavina A., Turubanova S., Zalles V., Li X., Khan A., Stolle F., Harris N., Song X.-P., Baggett A., Kommareddy I., Kommareddy A. (2022) The global 2000-2020 land cover and land use change dataset derived from the Landsat archive: first results. Frontiers in Remote Sensing. [https://doi.org/10.3389/frsen.2022.856903](https://doi.org/10.3389/frsen.2022.856903). Accessed through Resource Watch, (date). [www.resourcewatch.org](https://www.resourcewatch.org).',
  },
};
